import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { useShallow } from "zustand/react/shallow";
import { memo } from "react";

import { useUIStore } from "@/stores/uiStore";

export const HeadConfig = memo(function HeadConfig() {
  const title = useUIStore(useShallow((state) => state.pageTitle));
  const { t } = useTranslation("pageTitle");

  return (
    <Helmet>
      <title>
        {title
          ? `${t("pageMeta.pageTitle")} - ${t(title, { name: "" })}`
          : t("pageMeta.pageTitle")}
      </title>
      <meta name={"description"} content={t("pageMeta.pageDescription")} />
      <meta name={"keywords"} content={t("pageMeta.pageKeywords")} />
      <meta name={"author"} content={t("pageMeta.pageAuthor")} />
    </Helmet>
  );
});
